exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-1081aebd] {\n  padding-bottom: 10px;\n}\n.filter-item[data-v-1081aebd] {\n  margin-right: 10px;\n}\n.line-text[data-v-1081aebd] {\n  line-height: 1.6;\n}\n.join-num[data-v-1081aebd] {\n  padding: 0 2px;\n  font-weight: bold;\n}\n.join-gap[data-v-1081aebd] {\n  margin-left: 6px;\n}\n", ""]);

// exports
